export default __webpack_public_path__ + "static/media/india.4d4c4349.jpg";